(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/share-coupon/assets/javascripts/share-button.js') >= 0) return;  svs.modules.push('/components/tipsen/share-coupon/assets/javascripts/share-button.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _Tippy = Tippy,
  TippyReact = _Tippy.default;
const _React = React,
  useState = _React.useState,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const log = svs.core.log;
const ReactButton = svs.ui.ReactButton;
const logger = log.getLogger('tipsen:share-button');
const ShareStatus = {
  None: 'None',
  CopiedToClipboard: 'CopiedToClipboard',
  CopiedToClipboardFallback: 'CopiedToClipboardFallback',
  Shared: 'Shared',
  Text: 'Text'
};
const noop = () => {};
const defaultShareConfig = {
  title: 'Spela hos Svenska Spel S&C',
  text: "Spela hos Svenska Spel S&C",
  url: '!!THIS WILL BE REPLACED!!!'
};
const defaultShareMessages = Object.values(ShareStatus).reduce((texts, status) => _objectSpread(_objectSpread({}, texts), {}, {
  [status]: 'Texten delades'
}), {});

const fallbackCopyTextToClipboard = text => new Promise((resolve, reject) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    const status = document.execCommand('copy');
    if (status) {
      resolve();
      return;
    }
    reject(new Error('Unable to copy url legacy way'));
  } catch (err) {
    reject(err);
  } finally {
    document.body.removeChild(textArea);
  }
});
const copyTextToClipboard = async text => {
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(text);
    return ShareStatus.CopiedToClipboard;
  }
  await fallbackCopyTextToClipboard(text);
  return ShareStatus.CopiedToClipboardFallback;
};
const share = async (url, shareConfig) => {
  const canShare = navigator && navigator.canShare && navigator.canShare(shareConfig);
  if (canShare) {
    try {
      await navigator.share(_objectSpread(_objectSpread({}, shareConfig), {}, {
        url
      }));
      return ShareStatus.Shared;
    } catch (err) {
      logger.info("Share aborted: ".concat(err.message));
      if (err.name === 'AbortError') {
        return ShareStatus.None;
      }
    }
  }
  return copyTextToClipboard(url);
};
const ShareButton = _ref => {
  let className = _ref.className,
    disabled = _ref.disabled,
    children = _ref.children,
    isTransparent = _ref.isTransparent,
    shareText = _ref.shareText,
    _ref$onShare = _ref.onShare,
    onShare = _ref$onShare === void 0 ? noop : _ref$onShare,
    _ref$shareConfig = _ref.shareConfig,
    shareConfig = _ref$shareConfig === void 0 ? defaultShareConfig : _ref$shareConfig,
    _ref$shareMessages = _ref.shareMessages,
    shareMessages = _ref$shareMessages === void 0 ? defaultShareMessages : _ref$shareMessages,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 300 : _ref$size;
  const timeout = useRef();
  const _useState = useState(ShareStatus.None),
    _useState2 = _slicedToArray(_useState, 2),
    shareStatus = _useState2[0],
    setShareStatus = _useState2[1];
  const isDisabled = disabled || !shareText;
  useEffect(() => () => {
    clearTimeout(timeout.current);
  });
  const onTippyShown = useCallback(() => {
    timeout.current = setTimeout(() => {
      setShareStatus(ShareStatus.None);
    }, 5000);
  }, []);
  const handleShare = async () => {
    let newShareStatus;
    try {
      newShareStatus = await share(shareText, shareConfig);
      onShare(true);
    } catch (err) {
      logger.info("Unable to share text: ".concat(err.message));
      newShareStatus = ShareStatus.Text;
      onShare(false);
    } finally {
      logger.info("Shared status: ".concat(newShareStatus));
      setShareStatus(newShareStatus);
    }
  };
  const classNames = ['share-button-btn qa-on-share'];
  if (shareStatus === ShareStatus.Text) {
    classNames.push('std-input std-input-100');
  }
  if (className && className.length > 0) {
    classNames.push(className);
  }
  const renderContent = () => {
    if (shareStatus === ShareStatus.Text) {
      return React.createElement(React.Fragment, null, React.createElement("input", {
        className: classNames.join(' '),
        name: "shareInput",
        readOnly: true,
        ref: node => {
          if (!node) {
            return;
          }
          node.focus();
          node.select();
        },
        type: "text",
        value: shareText
      }), shareMessages[shareStatus]);
    }
    return React.createElement(ReactButton, {
      block: true,
      className: classNames.join(' '),
      disabled: isDisabled,
      onClick: handleShare,
      size: size,
      thin: true,
      transparent: isTransparent
    }, children);
  };
  return React.createElement(TippyReact, {
    content: shareMessages[shareStatus],
    onShown: onTippyShown,
    theme: "light-border",
    trigger: "manual",
    visible: ![ShareStatus.None, ShareStatus.Shared, ShareStatus.Text].includes(shareStatus)
  }, React.createElement("p", null, renderContent()));
};
setGlobal('svs.components.tipsen.shareCoupon.ShareButton', ShareButton);
setGlobal('svs.components.tipsen.shareCoupon.ShareStatus', ShareStatus);

 })(window);